import axios from 'axios';
import { getBackOfficeRoute, headers } from './header';
import { ROLE_ADMIN } from '../../constants/roles';

const SitesApiService = {

  getSites(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/sites`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getLldSites(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/sites/lld`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postAdminSites(token, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/sites`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putSites(token, role, siteId, data) {
    return axios
      .put(`${getBackOfficeRoute(role)}/sites/${siteId}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getSitesLld(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/sites/lld`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default SitesApiService;



// WEBPACK FOOTER //
// ./src/services/api/SitesApiService.js